import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { app } from './firebase';

const db      = app ? getFirestore(app) : null;
const storage = app ? getStorage(app) : null;

// Business verification doc (public liability certificate of currency, etc.)
// — private storage path (see storage.rules): only the uploader and the admin
// can ever read it back, unlike tour images which are public.
export async function uploadBusinessInsuranceDoc(uid, file) {
  const storageRef = ref(storage, `businessDocs/${uid}/${Date.now()}_${file.name}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}

// Business logo — public storage path (see storage.rules), shown on
// Community cards/detail pages when useBusinessIdentity is on.
export async function uploadBusinessLogo(uid, file) {
  const storageRef = ref(storage, `businessLogos/${uid}/${Date.now()}_${file.name}`);
  await uploadBytes(storageRef, file);
  return getDownloadURL(storageRef);
}

// Public profile: bio, links, business info. Stored separately from the
// sensitive `users` doc so it can be world-readable.
export async function getProfile(uid) {
  if (!db || !uid) return null;
  const snap = await getDoc(doc(db, 'profiles', uid));
  return snap.exists() ? { uid, ...snap.data() } : null;
}

export async function saveProfile(uid, data) {
  if (!db || !uid) return;
  await setDoc(doc(db, 'profiles', uid), data, { merge: true });
}

// Optional email notifications (transactional emails — booking confirmations,
// refunds — are always sent). Missing keys default to true.
export const DEFAULT_EMAIL_PREFS = {
  follows: true,          // "someone you follow published a route/tour"
  newRegistration: true,  // organizer: "a rider registered for your tour"
  tourUpdates: true,      // rider: "a tour you're registered for was updated"
  tourReminder: true,     // rider: "a tour you're registered for is tomorrow"
};

export function withEmailPrefDefaults(prefs) {
  return { ...DEFAULT_EMAIL_PREFS, ...(prefs || {}) };
}

const REPUTATION_URL =
  'https://us-central1-roamr-4f8ad.cloudfunctions.net/getRiderReputation';

// Verified rider stats (rides attended, riders guided, routes, …) for the
// profile reputation strip. Public — no auth needed; server caches 6h.
export async function getRiderReputation(uid) {
  if (!uid) return null;
  const res = await fetch(REPUTATION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uid }),
  });
  if (!res.ok) throw new Error(`Reputation lookup failed (${res.status})`);
  return res.json();
}
